import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import AddressBookInfo from "./modules/AddressBookInfo";
import { queryDepartTreeList, searchByKeywords } from '@/api/api';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
export default {
  name: 'AddressBook',
  mixins: [JeecgListMixin],
  components: {
    AddressBookInfo: AddressBookInfo
  },
  data: function data() {
    return {
      currentDeptId: '',
      iExpandedKeys: [],
      loading: false,
      autoExpandParent: true,
      currFlowId: '',
      currFlowName: '',
      disable: true,
      treeData: [],
      visible: false,
      departTree: [],
      rightClickSelectedKey: '',
      hiding: true,
      model: {},
      dropTrigger: '',
      depart: {},
      disableSubmit: false,
      checkedKeys: [],
      selectedKeys: [],
      autoIncr: 1,
      currSelected: {},
      form: this.$form.createForm(this),
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      graphDatasource: {
        nodes: [],
        edges: []
      }
    };
  },
  methods: {
    callback: function callback(key) {
      console.log(key);
    },
    loadData: function loadData() {
      this.refresh();
    },
    loadTree: function loadTree() {
      var _this = this;

      var that = this;
      that.treeData = [];
      that.departTree = [];
      queryDepartTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.treeData.push(temp);
            that.departTree.push(temp);
            that.setThisExpandedKeys(temp); // console.log(temp.id)
          }

          _this.loading = false;

          _this.$refs.DeptUserInfo.onClearSelected();

          _this.$refs.DeptUserInfo.open(null);
        }
      });
    },
    setThisExpandedKeys: function setThisExpandedKeys(node) {
      if (node.children && node.children.length > 0) {
        this.iExpandedKeys.push(node.key);
      }
    },
    refresh: function refresh() {
      this.loading = true;
      this.loadTree();
    },
    onExpand: function onExpand(expandedKeys) {
      // console.log('onExpand', expandedKeys)
      // if not set autoExpandParent to false, if children expanded, parent can not collapse.
      // or, you can remove all expanded children keys.
      this.iExpandedKeys = expandedKeys;
      this.autoExpandParent = true;
    },
    onSearch: function onSearch(value) {
      var that = this;

      if (value) {
        searchByKeywords({
          keyWord: value
        }).then(function (res) {
          if (res.success) {
            that.departTree = [];

            for (var i = 0; i < res.result.length; i++) {
              var temp = res.result[i];
              that.departTree.push(temp);
            }
          } else {
            that.$notification.warning({
              message: res.message
            });
          }
        });
      } else {
        that.loadTree();
      }
    },
    onCheck: function onCheck(checkedKeys, e) {
      var record = e.node.dataRef; // console.log('onCheck', checkedKeys, e);

      this.checkedKeys = []; // if (e.checked === true) {

      this.currentDeptId = record.id;
      this.checkedKeys.push(record.id);
      this.$refs.DeptBaseInfo.open(record);
      this.$refs.DeptUserInfo.open(record); // }
      // else {
      //   this.checkedKeys = [];
      //   this.$refs.DeptBaseInfo.clearForm();
      //   this.$refs.DeptUserInfo.clearList();
      // }

      this.hiding = false; // this.checkedKeys = checkedKeys.checked
    },
    onSelect: function onSelect(selectedKeys, e) {
      if (this.selectedKeys[0] !== selectedKeys[0]) {
        this.selectedKeys = [selectedKeys[0]];
      }

      var record = e.node.dataRef;
      this.checkedKeys.push(record.id);
      this.$refs.DeptUserInfo.onClearSelected();
      this.$refs.DeptUserInfo.open(record);
    }
  },
  created: function created() {
    this.currFlowId = this.$route.params.id;
    this.currFlowName = this.$route.params.name; // this.loadTree()
  }
};